import { Component, inject } from '@angular/core';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {CategoryType, ICategoryData, CategoryDefault} from '../../models';
import {FormUtil} from '../../utils';
import {TrackingService} from '../../services';

@Component({
    selector: 'app-quickscan-create-update-category-modal',
    templateUrl: './quickscan-create-update-category-modal.component.html',
    styleUrls: ['./quickscan-create-update-category-modal.component.scss'],
    standalone: false
})
export class QuickscanCreateUpdateCategoryModalComponent {
    public modalRef = inject(VwuiModalRef);
    public modalConfig = inject<VwuiModalConfig<{ title: string; data?: ICategoryData; saveText: string; }>>(VwuiModalConfig);
    private trackingService = inject(TrackingService);


    public form: UntypedFormGroup;
    public loading = false;

    public title: string;
    public saveText: string;
    public data?: ICategoryData;
    public categoryTypes = CategoryType;
    public categoryType: string = CategoryType.RISK;

    constructor() {
        const modalConfig = this.modalConfig;

        this.title = modalConfig.data.title;
        this.saveText = modalConfig.data.saveText;
        this.data = modalConfig.data.data;

        const nameValue = this.data && this.data.name ? this.data.name : CategoryDefault.name;
        const typeValue = this.data && this.data.type ? this.data.type : CategoryDefault.type;
        const weightedScoreValue = this.data && this.data.weightedScore ? this.data.weightedScore : CategoryDefault.weightedScore;

        this.form = new UntypedFormGroup({
            name: new UntypedFormControl(nameValue, Validators.required),
            type: new UntypedFormControl(typeValue, Validators.required),
            weightedScore: new UntypedFormControl(weightedScoreValue, Validators.required)
        });

        this.setType(typeValue);
    }

    public setType(type: CategoryType) {
        this.categoryType = type;

        this.form.setValue({...this.form.value, ...{
            type
        }});
    }

    public submit() {
        try {
            FormUtil.validate(this.form);

            if (this.form.valid) {
                const updatedValues: ICategoryData = {...this.data, ...this.form.value};
                this.modalRef.close(updatedValues);
            }
        } catch (e) {
            console.error('Creating category failed: ', e);
            this.trackingService.exception(e);
        }
    }

}
